"use client";

import { useLingui } from "@lingui/react/macro";
import { VehicleIcon } from "@offstreetparking/design-system/icons/VehicleIcon";
import type { PropsWithChildren } from "react";
import { FlowModal as Modal } from "../overlays/FlowModal/FlowModal";
import { FlowModalTitle as ModalTitle } from "../overlays/FlowModal/FlowModalTitle";
type VehicleModalProps = {
	title: string;
	isOpen: boolean;
	onClose: () => void;
};
export const VehicleModal = ({ isOpen, onClose, title, children }: PropsWithChildren<VehicleModalProps>) => {
	const { t } = useLingui();
	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			variant="fullScreen"
			size="md"
			i18n={{
				closeButton: t`Close`,
				cancelButton: t`Cancel`,
			}}
		>
			<ModalTitle
				variant="fullScreen"
				icon={<VehicleIcon className="h-5 w-5" />}
				onClose={onClose}
				i18n={{
					closeButton: t`Close`,
				}}
			>
				{title}
			</ModalTitle>
			<div className="pt-2">{children}</div>
		</Modal>
	);
};
